
interface FacebookSuccessMessageProps {
  hasConnectedFacebook: boolean;
}

export const FacebookSuccessMessage = ({ hasConnectedFacebook }: FacebookSuccessMessageProps) => {
  return (
    <div className="mt-2 p-2 bg-blue-50 border border-blue-200 rounded text-center">
      <p className="text-xs text-blue-700 font-medium">
        ✅ Facebook Sharing Ready - works with native sharing
      </p>
    </div>
  );
};
